module.exports = __webpack_public_path__ + "static/img/Pluto.af9d3bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/Pluto.svg
// module id = 1415
// module chunks = 0